import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NavigationItem } from '../../../../../../../aumico-components/src/lib';
import { ReportScope } from '../../models/controls.model';

/**
 * Bilanz / Erfolgsrechnung switch — underline-tab slider styled to match the
 * `grouping-masking` page and the export modal. Same `ham-tab-navigation`
 * component, same `[style]="'underline'"` + `[color]="'primary'"` — so the
 * visual idiom is consistent across the app.
 *
 * The component owns local `navigationItems` mirroring the parent's `scope`
 * input. We keep that in sync via `ngOnChanges` so the active underline
 * follows external `scope` changes (e.g. URL / store rehydration).
 */
@Component({
    selector: 'report-scope-toggle',
    template: `
        <ham-tab-navigation
            [navigationItems]="navigationItems"
            [tabsTitles]="[
                'aumico_analytics_controls_scope_balance' | i18next,
                'aumico_analytics_controls_scope_income' | i18next
            ]"
            [style]="'underline'"
            [color]="'primary'"
            (tabClick)="onTabClick($event)"
        ></ham-tab-navigation>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportScopeToggleComponent implements OnChanges {
    @Input() public scope: ReportScope = 'bilanz';
    @Output() public scopeChange = new EventEmitter<ReportScope>();

    /** `name` is the stable scope identifier; the displayed label comes from
     *  the i18n pipe applied in the template above. */
    public navigationItems: NavigationItem[] = [
        { name: 'aumico_analytics_controls_scope_balance', active: true },
        { name: 'aumico_analytics_controls_scope_income', active: false },
    ];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['scope']) {
            this.syncFromScope();
        }
    }

    private syncFromScope(): void {
        const balanceActive = this.scope === 'bilanz';
        this.navigationItems = [
            { name: 'aumico_analytics_controls_scope_balance', active: balanceActive },
            { name: 'aumico_analytics_controls_scope_income', active: !balanceActive },
        ];
    }

    public onTabClick(item: NavigationItem): void {
        const next: ReportScope = item.name === 'aumico_analytics_controls_scope_balance' ? 'bilanz' : 'erfolg';
        if (next !== this.scope) {
            this.scopeChange.emit(next);
        }
    }
}
